import { HttpInterceptorFn } from '@angular/common/http';

import { NameServiceCloudService } from './state.service';
import { inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { defer, from, switchMap } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('assets')) {
    return next(req);
  }

  const stateService = inject(NameServiceCloudService);
  const keycloakService = inject(KeycloakService);

  const url = req.url;
  // const port = url.split(':')[2].split('/')[0];
  const service = url.split('/')[3];
  stateService.setService(service);

  const token: string | null = localStorage.getItem('username');

  if (!token) {
    return next(req);
  }

  if (req.url.includes('/auth/register')) {
    return next(req);
  }

  return defer(() => from(keycloakService.updateToken(60))).pipe(
    switchMap(() => from(keycloakService.getToken())),
    switchMap((token) => {
      if (!token) {
        //Redirect to login
        keycloakService.login();
        return next(req);
      }

      const isReportRequest = req.url.includes('/report');

      const headers = {
        Accept: isReportRequest ? 'text/csv' : 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache',
        Authorization: `Bearer ${token}`,
      };

      const reqWithHeader = req.clone({ setHeaders: { ...headers } });

      return next(reqWithHeader);
    }),
  );
};
